<template>
	<div>
		<div class="main">
			<div class="w-full flex justify-start">
				<div class="flex gap-6" style="height: 400px; min-height: 400px; min-width: 800px; max-width: 900px; position: relative">
					<div class="bg-gray-400 rounded-md w-1/2 p-10 cursor-pointer" @click="$router.push({ name: 'repair_shop.ad_templates' })">
						<div class="flex text-center justify-center mb-12 mt-10">
							<font-awesome-icon :icon="['fas', 'copy']" class="text-white mr-2 text-center" style="font-size: 60px" />
						</div>
						<div class="font-bold">
							{{ $t('select_from_connect_templates') }}
						</div>
						<div class="mt-4">
							{{ $t('connect_templates_explanation') }}
						</div>
					</div>
					<div class="bg-gray-400 rounded-md w-1/2 p-10 cursor-pointer" @click="$router.push({ name: 'repair_shop.company_ads.create_ad' })">
						<div class="flex text-center justify-center mb-12 mt-10">
							<font-awesome-icon :icon="['fas', 'pencil-ruler']" class="text-white mr-2 text-center" style="font-size: 60px" />
						</div>
						<div class="font-bold">
							{{ $t('setup_own_ad') }}
						</div>
						<div class="mt-4">
							{{ $t('setup_own_ad_explanation') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SelectAdType',
	mixins: [],
	data() {
		return {};
	},
};
</script>

<style scoped></style>
